async function checkMail() {
  const res = await fetch(`${process.env.REACT_APP_API_URL as string}/check`);
  return res.json();
}

async function sendMail(mail: FormData) {
  return fetch(`${process.env.REACT_APP_API_URL as string}/mail`, {
    body: mail,
    method: 'post',
  }).catch((err) => {
    console.log('ici');
    throw err;
  });
}

export { checkMail, sendMail };
